import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { FiltroIndicadorRecuperacion } from "./Filtro/FiltroIndicadorRecuperacion";
import request from "../../../Helpers/API";
import { GetKey } from "../../../Helpers/GetKey";
import { useBox } from "../ReporteCobranza/Helper/useBox";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../components/LoaderScreen";
import SaveIcon from "@mui/icons-material/Save";
import { MicNone } from "@mui/icons-material";

export const IndicadorSemaforoScreen = ({ boxstate, tipoCartera }) => {
  // const [boxstate, setBoxState] = useBox();
  const [data, setData] = useState({});
  const [post, setPost] = useState([]);
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  // Meses del año
  const meses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  useEffect(() => {
    // setLoader({ ...loader, mostrar: true });
    onExecute(boxstate.ejercicio);
    // setLoader({ ...loader, mostrar: false });
  }, []);

  const onGuardar = () => {
    setLoader({ ...loader, mostrar: true });

    request
      .post("IndicadoresRecuperacion/GuardarSemaforo", post)
      .then(async () => {
        setLoader({ ...loader, mostrar: false });
        await Swal.fire(
          "INDICADORES RECUPERACION",
          "Se registraron los indicadores",
          "success"
        );
        setPost([]); // Limpiamos el post después de guardar
        onExecute(boxstate.ejercicio);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("FACTURACION", JSON.stringify(error), "error");
      });
  };

  const formatData = (data) => {
    const formatted = {};

    data.forEach((item) => {
      const semaforo = item.semaforo;
      formatted[semaforo] = {
        meses: [
          { minimo: item.enero_minimo, maximo: item.enero_maximo },
          { minimo: item.febrero_minimo, maximo: item.febrero_maximo },
          { minimo: item.marzo_minimo, maximo: item.marzo_maximo },
          { minimo: item.abril_minimo, maximo: item.abril_maximo },
          { minimo: item.mayo_minimo, maximo: item.mayo_maximo },
          { minimo: item.junio_minimo, maximo: item.junio_maximo },
          { minimo: item.julio_minimo, maximo: item.julio_maximo },
          { minimo: item.agosto_minimo, maximo: item.agosto_maximo },
          { minimo: item.septiembre_minimo, maximo: item.septiembre_maximo },
          { minimo: item.octubre_minimo, maximo: item.octubre_maximo },
          { minimo: item.noviembre_minimo, maximo: item.noviembre_maximo },
          { minimo: item.diciembre_minimo, maximo: item.diciembre_maximo },
        ],
        autoriza_gerencia_cobranza: item.autoriza_gerencia_cobranza,
        autoriza_gerencia_finanzas: item.autoriza_gerencia_finanzas,
        ejercicio: item.ejercicio,
        usuario: item.usuario,
        tipo_indicador: item.tipo_indicador,
        tipo_cartera: item.tipo_cartera,
        idIndicador: item.idIndicador,
      };
    });

    return formatted;
  };

  const onExecute = (ejercicio) => {
    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `IndicadoresRecuperacion/ListadoSemaforo?ejercicio=${ejercicio}&tipo_cartera=${tipoCartera}`
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          if (result && Array.isArray(result)) {
            const formattedData = formatData(result);
            setData(formattedData);
          }
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
        });
    });
  };

  const handleChange = (semaforo, monthIndex, minValue, maxValue) => {
    // if (minValue > maxValue) {
    //     minValue = maxValue - 1
    // }

    //validar que el valor minimo no sea mayor al maximo
    // if (minValue > maxValue) {
    //     // Muestra una alerta si el valor es mayor a 100
    //     Swal.fire({
    //         icon: 'warning',
    //         title: 'Valor excedido',
    //         text: 'El valor minimo no puede ser mayor al maximo',
    //     });

    //     // Establecemos el valor máximo permitido (100)
    //     minValue = maxValue - 1;
    // }

    if (maxValue > 100) {
      // Muestra una alerta si el valor es mayor a 100
      Swal.fire({
        icon: "warning",
        title: "Valor excedido",
        text: "El valor no puede ser mayor a 100. Se ajustará a 100.",
      });

      // Establecemos el valor máximo permitido (100)
      maxValue = 100;
    }

    setData((prevData) => {
      const newData = { ...prevData };

      // Si no existe el semáforo, inicializamos sus datos
      if (!newData[semaforo]) {
        newData[semaforo] = {
          meses: Array(12).fill({ minimo: 0, maximo: 0 }), // Inicializamos con objetos con min y max
          autoriza_gerencia_cobranza: false,
          autoriza_gerencia_finanzas: false,
          ejercicio: 2024,
          tipo_indicador: "RCO",
          tipo_cartera: "J",
          semaforo: "V",
          idIndicador: 0,
        };
      }

      // Actualizamos los valores min y max para el mes
      newData[semaforo].meses[monthIndex] = {
        minimo: minValue,
        maximo: maxValue,
      };

      // Nos aseguramos de que el idIndicador no sea null, o lo inicializamos si es necesario
      newData[semaforo].idIndicador = newData[semaforo].idIndicador || 0;

      // Actualiza `post` directamente como un array
      setPost((prevPost) => {
        const updatedPost = [...prevPost];
        const existingIndex = updatedPost.findIndex(
          (item) => item.semaforo === semaforo
        );

        const updatedItem = {
          idIndicador: newData[semaforo].idIndicador, // Asegúrate de usar la propiedad correcta
          tipo_indicador: newData[semaforo].tipo_indicador,
          tipo_cartera: newData[semaforo].tipo_cartera,
          semaforo: semaforo,
          ejercicio: newData[semaforo].ejercicio,
          enero_minimo: newData[semaforo].meses[0].minimo,
          enero_maximo: newData[semaforo].meses[0].maximo,
          febrero_minimo: newData[semaforo].meses[1].minimo,
          febrero_maximo: newData[semaforo].meses[1].maximo,
          marzo_minimo: newData[semaforo].meses[2].minimo,
          marzo_maximo: newData[semaforo].meses[2].maximo,
          abril_minimo: newData[semaforo].meses[3].minimo,
          abril_maximo: newData[semaforo].meses[3].maximo,
          mayo_minimo: newData[semaforo].meses[4].minimo,
          mayo_maximo: newData[semaforo].meses[4].maximo,
          junio_minimo: newData[semaforo].meses[5].minimo,
          junio_maximo: newData[semaforo].meses[5].maximo,
          julio_minimo: newData[semaforo].meses[6].minimo,
          julio_maximo: newData[semaforo].meses[6].maximo,
          agosto_minimo: newData[semaforo].meses[7].minimo,
          agosto_maximo: newData[semaforo].meses[7].maximo,
          septiembre_minimo: newData[semaforo].meses[8].minimo,
          septiembre_maximo: newData[semaforo].meses[8].maximo,
          octubre_minimo: newData[semaforo].meses[9].minimo,
          octubre_maximo: newData[semaforo].meses[9].maximo,
          noviembre_minimo: newData[semaforo].meses[10].minimo,
          noviembre_maximo: newData[semaforo].meses[10].maximo,
          diciembre_minimo: newData[semaforo].meses[11].minimo,
          diciembre_maximo: newData[semaforo].meses[11].maximo,
          autoriza_gerencia_finanzas:
            newData[semaforo].autoriza_gerencia_finanzas,
          autoriza_gerencia_cobranza:
            newData[semaforo].autoriza_gerencia_cobranza,
        };

        if (existingIndex !== -1) {
          // Si ya existe un objeto con el semáforo, actualízalo
          updatedPost[existingIndex] = updatedItem;
        } else {
          // Si no existe, agrégalo
          updatedPost.push(updatedItem);
        }

        return updatedPost;
      });

      return newData;
    });
  };

  return (
    <div>
      <LoaderScreen loader={loader} />

      {/* <FiltroIndicadorRecuperacion
                onExecute={onExecute}
                boxState={boxstate}
                onBoxChange={setBoxState}
            /> */}
      <div className="indicador-semaforo-tabla-main-container scroll">
        <table
          cellPadding={0}
          cellSpacing={0}
          // border="1"
        >
          <thead>
            <tr>
              <th>Tipo</th>
              {meses.map((mes, index) => (
                <th key={index} colSpan="2">
                  {mes}
                </th>
              ))}
            </tr>
            <tr>
              <th></th>
              {meses.map((mes, index) => (
                <>
                  <th key={`min-${index}`}>Min</th>
                  <th key={`max-${index}`}>
                    <div>Max</div>
                  </th>
                </>
              ))}
            </tr>
          </thead>
          <tbody>
            {Object.keys(data).map((semaforo, rowIndex) => (
              <tr key={rowIndex}>
                <td>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {semaforo === "V " ? (
                      <div className="alert-success" />
                    ) : semaforo === "A " ? (
                      <div className="alert-yellow" />
                    ) : semaforo === "R " ? (
                      <div className="alert-red" />
                    ) : semaforo === "RR" ? (
                      <div className="separacion-indicadores">
                        <div className="alert-double-red" />
                        <div className="alert-red" />
                      </div>
                    ) : (
                      <></> // Si no hay coincidencia, no muestra ícono
                    )}
                    {semaforo === "V "
                      ? "Verde"
                      : semaforo === "A "
                      ? "Amarillo"
                      : semaforo === "R "
                      ? "Rojo"
                      : semaforo === "RR"
                      ? "Doble Rojo"
                      : "No Identificado"}
                  </div>
                </td>
                {data[semaforo].meses.map((value, monthIndex) => (
                  <>
                    <td
                      className="indicador-semaforo-tabla-minimo"
                      key={`min-${monthIndex}`}
                    >
                      <input
                        type="number"
                        value={value.minimo}
                        onChange={(e) =>
                          handleChange(
                            semaforo,
                            monthIndex,
                            e.target.value,
                            value.maximo
                          )
                        }
                        placeholder="Min %"
                        // style={{ width: '80px', textAlign: 'center' }}
                      />
                    </td>
                    <td
                      className="indicador-semaforo-tabla-maximo"
                      key={`max-${monthIndex}`}
                    >
                      <input
                        type="number"
                        value={value.maximo}
                        onChange={(e) =>
                          handleChange(
                            semaforo,
                            monthIndex,
                            value.minimo,
                            e.target.value
                          )
                        }
                        placeholder="Max %"
                        // style={{ width: '80px', textAlign: 'center' }}
                      />
                    </td>
                  </>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {Object.keys(post).length > 0 && (
        <div className="indicador-recuperacion-boton-guardar-container">
          <button
            className="indicador-recuperacion-boton-guardar"
            onClick={() => onGuardar()}
          >
            <SaveIcon />
            Guardar
          </button>
        </div>
      )}
    </div>
  );
};
